import React, { useState, useEffect } from 'react';

export default function TextButtonsModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    message: '',
    buttons: [],
    delay: 0,
    timeout: false,
    timeoutValue: 0
  });

  useEffect(() => {
    if (open && node?.data) {
      setFormData({
        message: node.data.message || '',
        buttons: node.data.buttons || [],
        delay: node.data.delay || 0,
        timeout: node.data.timeout || false,
        timeoutValue: node.data.timeoutValue || 0
      });
    }
  }, [open, node]);

  const handleSave = () => {
    onSave(node.id, formData);
    onClose();
  };

  const addButton = () => {
    if (formData.buttons.length < 3) { // WhatsApp allows max 3 buttons
      setFormData(prev => ({
        ...prev,
        buttons: [...prev.buttons, { label: '', target: null }]
      }));
    }
  };

  const removeButton = (index) => {
    setFormData(prev => ({
      ...prev,
      buttons: prev.buttons.filter((_, i) => i !== index)
    }));
  };

  const updateButton = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      buttons: prev.buttons.map((button, i) => 
        i === index ? { ...button, [field]: value } : button
      )
    }));
  };

  const updateMessage = (value) => {
    setFormData(prev => ({
      ...prev,
      message: value
    }));
  };

  const updateDelay = (value) => {
    setFormData(prev => ({
      ...prev,
      delay: parseInt(value) || 0
    }));
  };

  const toggleTimeout = () => {
    setFormData(prev => ({
      ...prev,
      timeout: !prev.timeout
    }));
  };

  const updateTimeoutValue = (value) => {
    setFormData(prev => ({
      ...prev,
      timeoutValue: parseInt(value) || 0
    }));
  };

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: 24,
        minWidth: 500,
        maxWidth: 600,
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0'
        }}>
          <div style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            background: '#25d366',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 12,
            fontSize: 20
          }}>
            💬🔘
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: '#333' }}>
              Message
            </h2>
            <p style={{ margin: 0, fontSize: 14, color: '#666' }}>
              Configure text message with buttons
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              marginLeft: 'auto',
              background: 'none',
              border: 'none',
              fontSize: 24,
              cursor: 'pointer',
              color: '#999',
              padding: 4
            }}
          >
            ×
          </button>
        </div>

        {/* Message Input */}
        <div style={{ marginBottom: 20 }}>
          <label style={{
            display: 'block',
            marginBottom: 8,
            fontSize: 14,
            fontWeight: 500,
            color: '#333'
          }}>
            Message
          </label>
          <textarea
            value={formData.message}
            onChange={(e) => updateMessage(e.target.value)}
            placeholder="Type message..."
            style={{
              width: '100%',
              minHeight: 80,
              padding: 12,
              border: '1px solid #ddd',
              borderRadius: 8,
              fontSize: 14,
              fontFamily: 'inherit',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
          />
          <div style={{
            textAlign: 'right',
            fontSize: 12,
            color: '#666',
            marginTop: 4
          }}>
            {formData.message.length}/1024
          </div>
        </div>

        {/* Buttons Section */}
        <div style={{ marginBottom: 20 }}>
          <label style={{
            display: 'block',
            marginBottom: 12,
            fontSize: 14,
            fontWeight: 500,
            color: '#333'
          }}>
            Buttons
          </label>
          
          {formData.buttons.map((button, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 12,
              padding: 12,
              border: '1px solid #e0e0e0',
              borderRadius: 8,
              background: '#f9f9f9'
            }}>
              <button
                onClick={() => removeButton(index)}
                style={{
                  background: '#ff4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: 20,
                  height: 20,
                  cursor: 'pointer',
                  fontSize: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ×
              </button>
              
              <input
                type="text"
                value={button.label}
                onChange={(e) => updateButton(index, 'label', e.target.value)}
                placeholder="Button text"
                style={{
                  flex: 1,
                  padding: 8,
                  border: '1px solid #ddd',
                  borderRadius: 4,
                  fontSize: 14
                }}
              />
              
              <div style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                background: '#25d366',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: 12,
                cursor: 'pointer'
              }}
              title="Connection handle - drag to connect to other nodes"
              >
                ✓
              </div>
              
              <div style={{
                textAlign: 'right',
                fontSize: 12,
                color: '#666',
                minWidth: 40
              }}>
                {button.label.length}/20
              </div>
            </div>
          ))}
          
          {formData.buttons.length < 3 && (
            <button
              onClick={addButton}
              style={{
                width: '100%',
                padding: '12px',
                background: '#f0f0f0',
                border: '2px dashed #ccc',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: 14,
                color: '#666',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8
              }}
            >
              + Add Button
            </button>
          )}
        </div>

        {/* Delay Setting */}
        <div style={{ marginBottom: 20 }}>
          <label style={{
            display: 'block',
            marginBottom: 8,
            fontSize: 14,
            fontWeight: 500,
            color: '#333'
          }}>
            Set Delay
          </label>
          <input
            type="number"
            value={formData.delay}
            onChange={(e) => updateDelay(e.target.value)}
            placeholder="Type delay in seconds..."
            style={{
              width: '100%',
              padding: 12,
              border: '1px solid #ddd',
              borderRadius: 8,
              fontSize: 14,
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Timeout Setting */}
        <div style={{ marginBottom: 24 }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 8
          }}>
            <label style={{
              fontSize: 14,
              fontWeight: 500,
              color: '#333'
            }}>
              Set Timeout
            </label>
            <div style={{
              position: 'relative',
              width: 50,
              height: 24,
              background: formData.timeout ? '#25d366' : '#ccc',
              borderRadius: 12,
              cursor: 'pointer',
              transition: 'background 0.3s'
            }}
            onClick={toggleTimeout}
          >
            <div style={{
              position: 'absolute',
              top: 2,
              left: formData.timeout ? 26 : 2,
              width: 20,
              height: 20,
              background: 'white',
              borderRadius: '50%',
              transition: 'left 0.3s',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }} />
          </div>
          </div>
          
          {formData.timeout && (
            <input
              type="number"
              value={formData.timeoutValue}
              onChange={(e) => updateTimeoutValue(e.target.value)}
              placeholder="Timeout in seconds..."
              style={{
                width: '100%',
                padding: 12,
                border: '1px solid #ddd',
                borderRadius: 8,
                fontSize: 14,
                boxSizing: 'border-box'
              }}
            />
          )}
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: 12,
          marginTop: 24,
          paddingTop: 20,
          borderTop: '1px solid #e0e0e0'
        }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '12px 24px',
              background: '#f0f0f0',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 500,
              color: '#333'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            style={{
              flex: 1,
              padding: '12px 24px',
              background: '#25d366',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 500,
              color: 'white'
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
